import React, {useEffect, useLayoutEffect, useState} from "react";

import EggData from "./EggData"
import StepModal from "./stepModal/stepModal";
import PhotoPitcher from "./photoPitcher/photoPitcher";
import Modal from "../../UI/modal/modal"

const Steps = props =>{

    const[show,setShow] = useState(false)

    const isBrowser = typeof window !== "undefined";
    const lang = document.documentElement.lang === "it";


    const modalHandler = () => setShow(prev => !prev)

    useEffect(() =>{ props.isModalOpen && setShow(false)},[props.isModalOpen])


    useLayoutEffect(() => {
        window.addEventListener('resize', () => {
          document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`)
        });
      }, [isBrowser] )

    return(
        <>
            <section className={`full-height step-easter-egg step${props.whatStep + 1} ${props.isModalOpen && "info"}`}>
                <a href={lang ? "it.html" : "en.html"} >
                    <div className="closeHandler">
                        <svg className="closeHandler__close icon-open" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 41 41">
                            <g>
                            	<rect x="18.5" y="-4.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.4914 20.5)" width="4" height="49.5"/>
                            </g>
                            <g>
                            	<rect x="-4.2" y="18.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.4914 20.5)" width="49.5" height="4"/>
                            </g>
                        </svg>
                    </div>
                </a>

                    <div className="container-fluid full-height">
                        <div className="row full-height d-flex align-items-center">
                            <div className="col-md-10 m-auto">
                                <div className="row mt-lg-5">
                                    <div className="col-4 col-lg-6 text-end order-2 order-lg-1 step-easter-egg__number">
                                        <p className="mb-0">
                                            <span className="text-color">
                                                <b>{EggData[props.whatStep].number}</b>
                                            </span> | 06
                                        </p>
                                    </div>
                                    <div className="col-lg-6 d-none d-lg-block order-lg-2"></div>
                                    <div className="col-lg-6 order-3 order-lg-3 step-easter-egg__img gx-0 gx-md-4">
                                        <PhotoPitcher whatStep={props.whatStep} isModalOpen={props.isModalOpen} openModal={props.openModal} photo={EggData[props.whatStep].photo} />
                                        <Modal show={show} clicked={modalHandler}>
                                            <PhotoPitcher whatStep={props.whatStep} isModalOpen={props.isModalOpen} openModal={props.openModal} photo={EggData[props.whatStep].photo} />
                                        </Modal>
                                        <div className="icon-open d-block d-md-none text-center pe-none">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"
                                                 viewBox="0 0 60 60">
                                                <defs>
                                                    <filter id="Tracciato_108" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse">
                                                        <feOffset dy="3" input="SourceAlpha"/>
                                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                                        <feFlood floodOpacity="0.161"/>
                                                        <feComposite operator="in" in2="blur"/>
                                                        <feComposite in="SourceGraphic"/>
                                                    </filter>
                                                </defs>
                                                <g onClick={modalHandler} className="pe-auto btn" id="Open_40_-_color" data-name="Open 40 - color" transform="translate(10 7)">
                                                    <g transform="matrix(1, 0, 0, 1, -10, -7)" filter="url(#Tracciato_108)">
                                                        <path id="Tracciato_108-2" data-name="Tracciato 108" d="M40,237.2a20,20,0,1,0-20,20,20,20,0,0,0,20-20" transform="translate(10 -210.2)" stroke="#fff" strokeWidth="2"/>
                                                    </g>
                                                    <path id="Sottrazione_1" data-name="Sottrazione 1" d="M9.232,18H0V8.768L9.23,18ZM18,9.232l0,0L8.768,0H18V9.232Z" transform="translate(11.5 10.5)" fill="#fff"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="col-8 col-lg-6 order-1 order-lg-4 step-easter-egg__desc">
                                        <p className="ps-lg-5">{lang ? "Seleziona il cerchio" : "Select the circle"}<br className="d-none d-md-block"/> { lang ? "in cui si trova l'Easter Egg." : "where the Easter Egg is located."}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <StepModal isModalOpen={props.isModalOpen} nextStep={props.nextStep} calendar={EggData[props.whatStep].calendar} author={EggData[props.whatStep].author} titolo={EggData[props.whatStep].titolo} photo={EggData[props.whatStep].photoRef} description={EggData[props.whatStep].description} />
            </section>
        </>
    )
}

export default Steps